// @flow

export const TextAlign = {
    LEFT: 'TextAlign.LEFT',
    CENTER: 'TextAlign.CENTER',
    RIGHT: 'TextAlign.RIGHT'
};

export const TEXT_ALIGN_CLASSES: {[key: $Values<typeof TextAlign>]: ?string } = {
    [TextAlign.LEFT]: null,
    [TextAlign.CENTER]: 'table__col_center',
    [TextAlign.RIGHT]: 'table__col_right'
};

export const VerticalAlign = {
    DEFAULT: 'VerticalAlign.DEFAULT',
    TOP: 'VerticalAlign.TOP',
    MIDDLE: 'VerticalAlign.MIDDLE',
    BASELINE: 'VerticalAlign.BASELINE',
    BOTTOM: 'VerticalAlign.BOTTOM'
};

export const VERTICAL_ALIGN_CLASSES: (string) => {[key: $Values<typeof VerticalAlign>]: ?string } = elem => ({
    [VerticalAlign.DEFAULT]: null,
    [VerticalAlign.TOP]: `${elem}_v-align-top`,
    [VerticalAlign.MIDDLE]: `${elem}_v-align-middle`,
    [VerticalAlign.BASELINE]: `${elem}_v-align-baseline`,
    [VerticalAlign.BOTTOM]: `${elem}_v-align-bottom`
});

